import React, { useState } from 'react';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const Picha = () => {
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [lightboxIndex, setLightboxIndex] = useState(-1);

    const events = [
        {
            id: 1,
            title: "CPCT Mkutano Mkuu - Julai 2025",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_456.jpg?alt=media&token=16963104-587b-4005-86e8-5b845d42fe86",
        },
        {
            id: 2,
            title: "Makabidhiano ya Uongozi - Julai 2025",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmakabidhiano-2025%2FIMG_0069.jpg?alt=media&token=d5e69a4f-3a0d-4981-8caa-08ee9cb331f2",
        },
        // Add more events here as needed
    ];

    const photos = {
        1: [
            {
                id: 1,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_456.jpg?alt=media&token=16963104-587b-4005-86e8-5b845d42fe86'
            },
            {
                id: 2,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_14.jpg?alt=media&token=d6d7e299-c3d2-4d50-a2e8-6971a20270dc'
            },
            {
                id: 3,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_219.jpg?alt=media&token=54f3601b-69ce-49c4-9585-edcc542c4122'
            },
            {
                id: 4,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_234.jpg?alt=media&token=ff764a5c-5bde-4eb9-b6ee-d5ded71cf37e'
            },
            {
                id: 5,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_307.jpg?alt=media&token=c564c9a3-7ab9-4e37-903a-fb8cfc53d1d6'
            },

            {
                id: 6,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_318.jpg?alt=media&token=fcd009d6-5991-4d41-af24-4d46f3852261'
            },
            {
                id: 7,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_351.jpg?alt=media&token=8063b643-5c5e-4f2c-b209-b2ab9b007bbb'
            },
            {
                id: 8,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_382.jpg?alt=media&token=4f0b698c-e1c8-41d2-b610-f2a0c2a2579e'
            },
            {
                id: 9,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_396.jpg?alt=media&token=e75bf71f-186b-4dd1-9bc8-1d61f93b040e'
            },
            {
                id: 10,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_402.jpg?alt=media&token=88fd1ea7-270e-4b65-9f85-0979a93686ce'
            },
            {
                id: 11,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_405.jpg?alt=media&token=06c4a311-e5b3-4c23-a642-44560433afc7'
            },
            {
                id: 12,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_439.jpg?alt=media&token=daa0f48f-30d1-42a4-b6fb-598b34277332'
            },
            {
                id: 13,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_463.jpg?alt=media&token=7c84821d-8054-4bec-8da9-0f251ddd32c5'
            },
            {
                id: 15,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmkutano-mkuu-2025%2FCPCT_91.jpg?alt=media&token=0d29e2b9-b836-4629-9738-733703b65956'
            },
        ],
        2: [
            {
                id: 1,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmakabidhiano-2025%2FIMG_0069.jpg?alt=media&token=d5e69a4f-3a0d-4981-8caa-08ee9cb331f2'
            },
            {
                id: 2,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmakabidhiano-2025%2FIMG_0116.jpg?alt=media&token=aca6633d-a18d-40b5-832c-947079246062'
            },
            {
                id: 3,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmakabidhiano-2025%2FIMG_0130.jpg?alt=media&token=7e8bfb96-ba43-4bf7-975c-68c5c1c8508b'
            },
            {
                id: 4,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmakabidhiano-2025%2FIMG_0149.jpg?alt=media&token=4d94317a-736c-4030-8a72-9cf0f678bd9b'
            },
            {
                id: 5,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmakabidhiano-2025%2FIMG_9941.jpg?alt=media&token=fb168173-0412-4633-b371-6c3150eb60c1'
            },
            {
                id: 6,
                caption: '',
                url: 'https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/picha%2Fmakabidhiano-2025%2FIMG_9970.jpg?alt=media&token=0ed6ba00-b9d5-430b-8034-64e6227d76e2'
            },

        ]
    };

    const handleEventClick = (event) => {
        setSelectedEvent(event);
    };

    const handleBackClick = () => {
        setSelectedEvent(null);
    };

    // Render Photos Grid View
    if (selectedEvent) {
        const eventPhotos = photos[selectedEvent.id] || [];

        return (
            <div className="flex flex-col font-display text-[#1c1c1c] dark:text-gray-200">
                {/* Back Button */}
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <button
                        onClick={handleBackClick}
                        className="flex items-center text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors mb-6 bg-white dark:bg-gray-800 px-4 py-2 rounded-lg shadow-md hover:shadow-lg"
                    >
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Rudi
                    </button>
                </div>

                {/* Photos Grid */}
                <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 pb-12">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl lg:text-6xl">
                            {selectedEvent.title}
                        </h2>
                        <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-500 dark:text-gray-400">
                            Picha za tukio ({eventPhotos.length})
                        </p>
                    </div>

                    {eventPhotos.length > 0 ? (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                            {eventPhotos.map((photo, index) => (
                                <div
                                    key={photo.id}
                                    className="group relative overflow-hidden rounded-lg shadow-lg bg-white dark:bg-gray-800 transition-all duration-300 hover:shadow-xl cursor-pointer"
                                    onClick={() => setLightboxIndex(index)}
                                >
                                    <div className="aspect-w-4 aspect-h-3 bg-gray-200 dark:bg-gray-700">
                                        <img
                                            alt={photo.caption || `Photo ${photo.id}`}
                                            className="w-full h-64 object-cover transform transition-transform duration-500 group-hover:scale-105"
                                            src={photo.url}
                                            loading="lazy"
                                            // onError={(e) => {
                                            //     e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjNmNGY2Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzljYTBiZCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPlBpY2hhIEhhaXBhdGlrYW5hPC90ZXh0Pjwvc3ZnPg==';
                                            // }

                                        />
                                    </div>
                                    {photo.caption && (
                                        <div className="p-4">
                                            <p className="text-gray-700 dark:text-gray-300 text-sm">{photo.caption}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-12">
                            <p className="text-gray-500 dark:text-gray-400 text-lg">
                                Hakuna picha zilizopatikana kwa tukio hili.
                            </p>
                        </div>
                    )}
                </main>
                <Lightbox
                    index={lightboxIndex}
                    open={lightboxIndex >= 0}
                    close={() => setLightboxIndex(-1)}
                    slides={eventPhotos.map(p => ({ src: p.url, description: p.caption }))}
                />
            </div>
        );
    }

    // Render Events List View
    return (
        <div className="flex flex-col  font-display text-[#1c1c1c] dark:text-gray-200">
            <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="text-center mb-12" data-aos="fade-up">
                    <h2 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl lg:text-6xl">
                        Picha
                    </h2>
                    <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-500 dark:text-gray-400">
                        Tazama picha za matukio CPCT
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {events.map((event, idx) => (
                        <div
                            key={event.id}
                            data-aos="fade-up"
                            data-aos-delay={idx * 100}
                            className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
                            onClick={() => handleEventClick(event)}
                        >
                            <div className="aspect-w-1 aspect-h-1 bg-gray-200 dark:bg-gray-700">
                                <img
                                    alt={event.title}
                                    className="w-full h-full object-cover"
                                    src={event.image}
                                    onError={(e) => {
                                        e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjNmNGY2Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzljYTBiZCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPlBpY2hhIEhhaXBhdGlrYW5hPC90ZXh0Pjwvc3ZnPg==';
                                    }}
                                />
                            </div>
                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                            <div className="absolute bottom-0 left-0 p-6">
                                <h3 className="text-xl font-semibold text-white">{event.title}</h3>
                                {/*<p className="text-gray-200 text-sm mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">*/}
                                {/*    Bonyeza kuona picha*/}
                                {/*</p>*/}
                            </div>
                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                        </div>
                    ))}
                </div>

                {events.length === 0 && (
                    <div className="text-center py-12">
                        <p className="text-gray-500 dark:text-gray-400 text-lg">
                            Hakuna matukio yaliyopatikana kwa sasa.
                        </p>
                    </div>
                )}
            </main>
        </div>
    );
};

export default Picha;